import { useSelector } from 'react-redux'
import { Project } from '../../../../types/Project'
import { formatNumber, prettyLocation } from '../../../../utility'
import props from '../../../../redux/props'
import Upsert from '../Upsert/Upsert'

type Props = { data: Project; pullList: () => void }

const Item: React.FC<Props> = ({ data, pullList }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className="flex w-full items-center gap-2">
      <a className="w-3/12 block hover:underline" href={`/admin/survey/${data.uuid}`}>
        {data.name}
      </a>
      <div className="w-2/12 truncate">{prettyLocation(data.location)}</div>
      <div className="w-2/12">{data.employeeAmount}</div>
      <div className="w-2/12">{formatNumber(data.areaInQM) + t.generic.squareMeterSuffix}</div>
      <div className="w-2/12">{formatNumber(data.surveyCount)}</div>
      <div className="w-1/12 flex justify-center">
        <Upsert initData={data} pullList={pullList} />
      </div>
    </div>
  )
}

export default Item
